// extracted by mini-css-extract-plugin
module.exports = {"card":"style-module__card___1hC45","subjectName":"style-module__subjectName___3cWbG","detailsButton":"style-module__detailsButton___2OAkC"};